import { FC } from "react";
import { Availability } from "~/entities/baseEntities";

export enum AvailabilityViewVariant {
  Daily = "daily",
  Short = "short",
}

interface AvailabilityViewProps {
  availability: Availability[];
  variant?: AvailabilityViewVariant;
}

import styles from "./AvailabilityView.module.css";
import {
  getMappedAvailability,
  getReadableAvailability,
  getReadableDaysShort,
  getReadableHoursShort,
} from "~/helpers/siteHelpers";

const AvailabilityView: FC<AvailabilityViewProps> = ({
  availability,
  variant = AvailabilityViewVariant.Daily,
}) => {
  return variant === AvailabilityViewVariant.Daily ? (
    <>
      {Object.entries(getMappedAvailability(availability)).map(
        ([key, values]: [string, Availability[]]) => (
          <div key={key} className={styles.sectionRow}>
            <div>{key.replace(/^\w/, (c) => c.toUpperCase())}</div>
            <div>{`${getReadableAvailability(values)}`}</div>
          </div>
        ),
      )}
    </>
  ) : variant === AvailabilityViewVariant.Short ? (
    <>
      {availability.map((x, i) => {
        const dayText = getReadableDaysShort(x.applies);
        return (
          <span key={i}>
            {`${dayText}${dayText && "\xa0"}${getReadableHoursShort(x, "")}`}
          </span>
        );
      })}
    </>
  ) : (
    <></>
  );
};

export default AvailabilityView;
